{
	"meta": {
		"title": "Features — UpSquad",
		"description": "Every tool your organization needs — unified, AI-powered, and beautifully simple. Explore UpSquad's full feature set."
	},
	"hero": {
		"eyebrow": "Features",
		"title": "Built for the way",
		"title_accent": "communities actually work.",
		"subtitle": "Eleven features. One unified platform. Every tool your organization needs to run a thriving community — without juggling ten apps."
	},
	"premium_badge": "Premium",
	"try_it_free": "Try it free",
	"frames": {
		"feed": "Community feed on the web app",
		"messaging": "Messages on the web app",
		"events": "Events on the web app",
		"meetings": "Meetings with calendar on the web app",
		"clips": "Community clips on the mobile app",
		"match": "Match AI suggestions on the web app",
		"insights": "AI Insights on the web app",
		"members": "Member list on the web app",
		"analytics": "Analytics dashboard on the web app",
		"branded": "Branded mobile app preview, {{theme}} theme",
		"theming": "Community settings with theme picker"
	},
	"items": {
		"feed": {
			"eyebrow": "Social feed",
			"title": "Keep your community moving.",
			"bullets": [
				"Posts, polls, videos and files — all in one feed",
				"Filter by group, content type or recency",
				"Reactions, comments, bookmarks and pinned posts"
			]
		},
		"messaging": {
			"eyebrow": "Messaging",
			"title": "Every conversation in one place.",
			"bullets": [
				"Group channels for cohorts, teams or programs",
				"Direct messages with read receipts",
				"No more 'check your email' or scattered Slack tabs"
			]
		},
		"events": {
			"eyebrow": "Events",
			"title": "Run events that people actually show up to.",
			"bullets": [
				"Create free or paid events in minutes",
				"Built-in RSVP, registration and attendance tracking",
				"Integrated calendar view — members see what's coming"
			]
		},
		"meetings": {
			"eyebrow": "Meetings",
			"title": "Schedule 1:1s and group meetings with AI.",
			"bullets": [
				"Schedule meetings directly inside your community",
				"AI helps draft agendas with one click",
				"Match AI suggests who should meet based on goals"
			]
		},
		"clips": {
			"eyebrow": "Community clips",
			"title": "Share stories that build culture.",
			"bullets": [
				"Short-form community videos, vertical-first",
				"Members share moments, learnings and inspiration",
				"Keeps energy high between live events"
			]
		},
		"match": {
			"eyebrow": "Match AI",
			"title": "The networking engine for your community.",
			"bullets": [
				"Analyzes member profiles, goals and activity",
				"Recommends the right connections at the right time",
				"Members can book a meeting in one click from a match"
			]
		},
		"insights": {
			"eyebrow": "AI Insights",
			"title": "Intelligence about your community, on demand.",
			"bullets": [
				"Ask natural-language questions about member data",
				"Get instant answers grounded in your real activity",
				"Weekly automated reports delivered to your inbox"
			]
		},
		"members": {
			"eyebrow": "Member management",
			"title": "Know your members. Run your programs.",
			"bullets": [
				"Searchable directory with group filtering",
				"Last-active indicators so no one falls through the cracks",
				"Collect payments, track roles, manage cohorts"
			]
		},
		"analytics": {
			"eyebrow": "Analytics",
			"title": "Real data. Real decisions.",
			"bullets": [
				"Member growth, engagement and event attendance at a glance",
				"Export reports for stakeholders and funders",
				"Powered by the same data layer as AI Insights"
			]
		},
		"branded": {
			"eyebrow": "Branded mobile app",
			"title": "Your community. Your app. Seventy-two hours.",
			"bullets": [
				"Fully branded iOS and Android app with your logo and colors",
				"Live in the App Store in as little as three days",
				"Automatic updates — no developers needed, ever"
			]
		},
		"theming": {
			"eyebrow": "Community theming",
			"title": "Every community looks like yours.",
			"bullets": [
				"Pick from four signature themes or supply your own",
				"Your custom URL: yourorg.upsquad.us",
				"Upload your logo and cover image in two clicks"
			]
		}
	},
	"closing": {
		"title": "Ready to see it in action?",
		"subtitle": "Start free with no credit card, or book a 30-minute walkthrough with our team.",
		"cta_primary": "Sign up free",
		"cta_secondary": "Book a demo"
	}
}
